import React from 'react';
import styled from 'styled-components';
const StyledTag = styled.span `
  background-color: ${({ theme: { colors } }) => colors.primary};
  border-radius: 0.75rem;
  color: ${({ theme: { colors } }) => colors.white};
  display: inline-block;
  font-family: ${({ theme: { fonts } }) => fonts.sansSerif};
  font-size: 0.75rem;
  font-weight: 700;
  height: 1rem;
  line-height: 1rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  vertical-align: center;
  white-space: nowrap;
`;
export const Tag = ({ children = null, className, }) => {
    return React.createElement(StyledTag, { className: className }, children);
};
